import { useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Spacer } from '../Spacer';
import { Typography } from '../Typography';

// todo: needs a better name
const Information = ({ Icon, description, heading, show }) => {
  const theme = useTheme();

  if (!show) {
    return <></>;
  }

  return (
    <Spacer gap='m'>
      {React.cloneElement(Icon, { style: { flexShrink: 0 } })}

      <Spacer direction='vertical'>
        <Typography variant='h4' style={{ fontWeight: theme.fontWeights.medium }}>
          {heading}
        </Typography>
        <Typography style={{ color: theme.colors.secondaryTextColour }}>{description}</Typography>
      </Spacer>
    </Spacer>
  );
};

Information.defaultProps = {
  description: '',
};

Information.propTypes = {
  Icon: PropTypes.node.isRequired,
  description: PropTypes.string,
  heading: PropTypes.string.isRequired,
  show: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
};

export default Information;
